/** Presentation-only helpers for header DB status pill (no freshness logic changes). */

const DB_STATUS_WARN_HOURS = 12;

function parseCacheAgeHours(cacheStatus) {
  if (!cacheStatus || cacheStatus.cacheAgeHours == null || cacheStatus.cacheAgeHours === '') {
    return null;
  }
  const hours = parseFloat(cacheStatus.cacheAgeHours);
  return Number.isNaN(hours) ? null : hours;
}

export function getDbStatusTier(cacheStatus, isRefreshing = false) {
  if (isRefreshing) return 'loading';
  if (!cacheStatus) return 'loading';
  if (cacheStatus.isStale) return 'error';
  const hours = parseCacheAgeHours(cacheStatus);
  if (hours === null) return 'loading';
  if (hours >= DB_STATUS_WARN_HOURS) return 'warn';
  return 'ok';
}

export function getDbStatusLabel(cacheStatus, isRefreshing) {
  if (isRefreshing) return 'Refreshing…';
  if (!cacheStatus) return 'Loading…';
  const hours = parseCacheAgeHours(cacheStatus);
  if (hours === null) return 'Loading…';
  const h = hours.toFixed(1);
  if (cacheStatus.isStale) return `DB ${h}h`;
  return `DB ${h}h`;
}
